module.exports = __webpack_public_path__ + "img/re1.d58e3a63.png";